import { useEffect } from "react"

import * as UserDomain from "@/domain/user"
import { useServices } from "@/hooks/useServices"
import { useUser } from "@/hooks/useUser"

export const useServicesWithUser = () => {
  const { user } = useUser()
  const { intercom, logger } = useServices()
  const isReadyToIdentify = UserDomain.isUserVerified(user)
  const isReadyToUpdateIntercom =
    isReadyToIdentify && UserDomain.isFullNameDefined(user)

  useEffect(() => {
    if (isReadyToIdentify) logger.identify({ ...user, userType: "kodem" })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isReadyToIdentify])

  useEffect(() => {
    if (isReadyToUpdateIntercom) intercom.update(user)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isReadyToUpdateIntercom])
}
